import Dropdown from '../../utils/forms/Dropdown';
import FormValidator from '../../utils/forms/FormValidator';
import Module from '../../utils/modules/Module';

export default class FormModule extends Module {
  constructor(options) {
    super(options);

    this.DOMEl = this.options.element;
    this.id = this.options.id;

    this.formContainer = this.DOMEl.tagName === 'FORM' ? this.DOMEl : this.DOMEl.querySelector('form');

    this.fakeformContainer = this.DOMEl.querySelector('.form');

    if (this.formContainer) {
      this.init();
    }
    else {
      this.initFakeForm();
    }
  }

  init() {
    this.inputsFieldContainers = this.formContainer.querySelectorAll(".form-item-label");

    this.inputsFieldContainers.forEach(inputContainer => {
      if (inputContainer.querySelector('input')) {
        inputContainer.querySelector('input').addEventListener('blur', this.onBlurPlaceLabel.bind(this));
      }

      if (inputContainer.querySelector('textarea')) {
        inputContainer.querySelector('textarea').addEventListener('keyup', this.onBlurPlaceLabel.bind(this));
      }
    });

    // Quick fix for toggle in contact us.
    this.formContainer.querySelectorAll('input.toggle').forEach(element => {
      element.parentElement.classList.add('form-toggle');
    });

    // Custom select interactions
    this.customSelect = this.formContainer.querySelectorAll('.dropdown');

    if (this.customSelect.length !== 0) {
      this.customSelect.forEach((element, i) => {
        element.classList.add('dropdown-' + (i + 1) + '-' + `${this.id}`);

        this.dropDown = new Dropdown(document.querySelector('.dropdown-' + (i + 1) + '-' + `${ this.id }`));
      });
    }

    // Filter language and country options in search page.
    document.querySelectorAll('input.filter-language, input.filter-country, input.filter-institution, input.filter-resource_people_complete_name').forEach(element => element.addEventListener('input', this.filterOptions));

    // Front validation for contact us.
    if (this.formContainer.classList.contains('contact-us-form')) {
      this.formValidator = new FormValidator(this.formContainer, `${ this.id }-form-validator`);
    }
    else if (this.formContainer.classList.contains('webform-submission-form')) {
      this.formValidator = new FormValidator(this.formContainer, `${ this.id }`);
    }
  }

  /**
   * When there is no official <form>
   * Interaction with custom select
   * Used in node--resource
   */
  initFakeForm() {
    this.customSelect = this.fakeformContainer.querySelectorAll('.dropdown');

    // Custom select interactions.
    if (this.customSelect.length !== 0) {
      this.customSelect.forEach((element, i) => {
        element.classList.add('dropdown-' + (i + 1) + '-' + `${ this.id }`);

        this.dropDown = new Dropdown(document.querySelector('.dropdown-' + (i + 1) + '-' + `${ this.id }`));
      });
    }

    // Download chosen language.
    if (this.fakeformContainer.classList.contains('form-download')) {
      this.options = this.fakeformContainer.querySelectorAll('[type="radio"]');

      this.options.forEach(element => {
        element.addEventListener('click', this.downloadLanguage.bind(this));
      });
    }

    // Filter languages.
    if (this.fakeformContainer.classList.contains('form-language')) {
      this.options = this.fakeformContainer.querySelectorAll('[type="checkbox"]');

      this.options.forEach(element => {
        element.addEventListener('click', this.filterLanguages.bind(this));
      });
    }
  }

  /**
   * Animation of the label (fake placeholder)
   * @param e - input clicked
   */
  onBlurPlaceLabel(e) {
    const input = e.target;
    const parent = input.closest('.form-item-label');
    const label = parent.querySelector('label');

    if (input.value === '') {
      label.classList.remove('labelUp');
    }
    else {
      label.classList.add('labelUp');
    }
  };

  /**
   * Put the right url to download button
   * @param event - input radio clicked / checked
   */
  downloadLanguage(event) {
    const url = event.target.dataset.fileUrl;

    this.fakeformContainer.querySelector('.btn-secondary').setAttribute('href', url);
  }

  /**
   * Action to filter languages in resources
   */
  filterLanguages() {
    const allLanguagesList = this.fakeformContainer.closest('.tab-content').querySelectorAll('.resource-list');
    const allSelectedLanguages = this.fakeformContainer.querySelectorAll('[type="checkbox"]:checked');

    // Hide all list.
    allLanguagesList.forEach(list => list.setAttribute('hidden', 'true'));

    // Show selected languages.
    allSelectedLanguages.forEach(input => {
      this.fakeformContainer.closest('.tab-content').querySelector('.resource-list[data-langcode=' + input.value + ']').removeAttribute('hidden');
    });

    // Show everything if selected nothing
    if (allSelectedLanguages.length === 0) {
      allLanguagesList.forEach(list => list.removeAttribute('hidden'));
    }
  }

  filterOptions(event) {
    const items = event.target.closest('.sub-filters').querySelectorAll('.sub-filters-container li');
    const inputVal = event.target.value.toLowerCase();

    items.forEach(item => {
      if (item.innerText.toLowerCase().match(inputVal)) {
        item.style.display = 'initial';
      }
      else {
        item.style.display = 'none';
      }
    });
  }

}
